module.exports = __webpack_public_path__ + "static/img/财务章.115c987e.png";